// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles___wrapper___2ZZzh","header":"styles___header___1xBsA"};